<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectFirstMenu}}</a-breadcrumb-item>
				<a-breadcrumb-item>{{selectSecondMenu}}</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<a-button icon="sync" @click="apiLoginLogQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="登录日志查询">
				<div class="qinang-search-row">
                    <div class="qinang-search-col-3">
						<div class="qinang-search-col-title" style="width: 120px;">用户账号：</div>
						<a-input v-model="query.userName" style="width: 100%;" placeholder="请输入用户账号" />
					</div>
                    <div class="qinang-search-col-3">
						<div class="qinang-search-col-title" style="width: 120px;">登录状态：</div>
						<a-select v-model="query.status" style="width: 100%;" placeholder="请选择登录状态" allowClear>
							<a-select-option :value="2">成功</a-select-option>
							<a-select-option :value="4">失败</a-select-option>
						</a-select>
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title" style="width: 120px;">登录IP：</div>
						<a-input v-model="query.ipAddress" style="width: 100%;" placeholder="请输入登录IP地址" />
					</div>
				</div>
                <div class="qinang-search-row" style="margin-top: 10px;">
                    <div class="qinang-search-col-3">
                    </div>
                    <div class="qinang-search-col-3">
                    </div>
                    <div class="qinang-search-col-3">
                        <div  class="qinang-search-col-title" style="width: 100%;">
                            <a-button type="primary" icon="search" @click="apiLoginLogQueryList">查询</a-button>
                        </div>
                    </div>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<a-breadcrumb separator=">" style="padding: 12.5px 16px;" >
					<a-breadcrumb-item>
						登录日志列表
					</a-breadcrumb-item>
				</a-breadcrumb>
			</div>
			<a-table :columns="tableColumns" :data-source="tableData" row-key="loginLogId" :loading="tableLoading" :pagination="false">
                <span slot="index" slot-scope="text, record, index">
					{{(query.page - 1) * query.size + index + 1}}
				</span>
                <span slot="userName" slot-scope="userName">
					{{userName.userName}}
				</span>
                <span slot="ipAddress" slot-scope="ipAddress">
					{{ipAddress.ipAddress}}
				</span>
                <span slot="status" slot-scope="status">
					<span v-if="status.status == 2" style="color: green;">成功</span>
					<span v-if="status.status == 4" style="color: red;">失败</span>
				</span>
                <span slot="msg" slot-scope="msg">
					{{msg.msg || '-'}}
				</span>
                <span slot="loginTime" slot-scope="loginTime">
					{{qaUtil.timeFormat(loginTime.loginTime)}}
				</span>
            </a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'loginLog',
		data() {
			return {
				selectFirstMenu: window.sessionStorage.getItem('selectFirstMenu'),
				selectSecondMenu: window.sessionStorage.getItem('selectSecondMenu'),
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					userName: '',
					status: '',
					ipAddress: '',
					dateRange: []
				},

				tableData: [],
				tableColumns: [
					{
						title: '序号',
						key: 'loginLogId',
						align: 'center',
                        scopedSlots: {
							customRender: 'index'
						}
					},
					{
						title: '用户账号',
						dataIndex: 'userName',
						key: 'userName',
						align: 'center',
					},
					{
						title: '登录IP地址',
						dataIndex: 'ipAddress',
						key: 'ipAddress',
						align: 'center',
					},
					{
						title: '登录状态',
						key: 'status',
						align: 'center',
						scopedSlots: {
							customRender: 'status'
						}
					},
					{
						title: '提示消息',
						dataIndex: 'msg',
						key: 'msg',
						align: 'center',
					},
					{
						title: '访问时间',
						dataIndex: 'loginTime',
						key: 'loginTime',
						align: 'center',
						scopedSlots: {
							customRender: 'loginTime'
						}
					}
				],
				tableLoading: false,
				//搜索+表格-end
			};
		},
		methods: {
			async apiLoginLogQueryList() {
				this.tableLoading = true
				let params = {
					page: this.query.page,
					size: this.query.size,
					userName: this.query.userName,
					status: this.query.status,
					ipAddress: this.query.ipAddress
				}
				// 处理日期范围
				if (this.query.dateRange && this.query.dateRange.length === 2) {
					params.startTime = this.moment(this.query.dateRange[0]).format('YYYY-MM-DD 00:00:00')
					params.endTime = this.moment(this.query.dateRange[1]).format('YYYY-MM-DD 23:59:59')
				}
				const {
					data: res
				} = await this.$http.post(this.navigation.apiLoginLogQueryList, params);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.total = res.data.pages.total
				} else {
					this.$message.error(res.msg)
				}
				this.tableLoading = false
			},
			pageChange(page, pageSize) {
				this.query.page = page
				this.apiLoginLogQueryList()
			},
			showSizeChange(current, size) {
				this.query.size = size
				this.query.page = 1
				this.apiLoginLogQueryList()
			}
		},
		created() {
			this.apiLoginLogQueryList()
		}
	};
</script>

<style scoped>
</style>
